import {
	createStreamMessage,
	listStream,
	hideStreamMessage as requestStreamMessageHide,
	reportStreamMessage as requestStreamMessageReport,
	starStreamMessage as requestStreamMessageStar,
	streamStatus,
} from "@/shared/api/generated-social"
import type { StreamMessage, StreamPage } from "../model/types"

export async function getStreamPage(params: {
	limit: number
	before: number | null
}): Promise<StreamPage> {
	const page = await listStream({
		query: {
			limit: params.limit,
			...(params.before !== null && { before: params.before }),
		},
	})
	return { ...page, items: page.items ?? [] }
}

export async function getStreamHasNew(): Promise<boolean> {
	const { has_new } = await streamStatus()
	return has_new
}

export function sendStreamMessage(text: string): Promise<StreamMessage> {
	return createStreamMessage({ body: { text } })
}

export function starStreamMessage(messageId: number): Promise<StreamMessage> {
	return requestStreamMessageStar({ path: { id: messageId } })
}

export async function hideStreamMessage(messageId: number): Promise<void> {
	await requestStreamMessageHide({ path: { id: messageId } })
}

export async function reportStreamMessage(messageId: number): Promise<void> {
	await requestStreamMessageReport({ path: { id: messageId } })
}
